// This file uses environment variables from .env.local (loaded by dotenv-webpack)
// Variables are injected at build time via process.env
// To update: Edit .env.local and restart the dev server
import { Environment } from './environment.interface';
import { NodeEnv } from '../app/core/enums/node-env.enum';
/**
 * Parses a comma-separated string into a trimmed string array.
 * Returns an empty array for falsy input.
 */
export const parseArray = (value: string): string[] =>
  value ? value.split(',').map(item => item.trim()) : [];
export const environment: Environment = {
  environment: process.env.REACT_APP_ENVIRONMENT,
  apiHost: process.env.REACT_APP_BLINK_HOST,
  baseHost: process.env.REACT_APP_BASE_HOST,
  qrHost: process.env.REACT_APP_QR_HOST,
  staticHost: process.env.REACT_APP_STATIC_HOST,
  defaultTenant: process.env.REACT_APP_DEFAULT_TENANT,
  tenants: parseArray(process.env.REACT_APP_TENANTS),
  version: process.env.REACT_APP_VERSION,
  muiKey: process.env.REACT_APP_MUI_X_KEY,
  pusherAppID: process.env.REACT_APP_PUSHER_APP_ID,
  pusherKey: process.env.REACT_APP_PUSHER_KEY,
  pusherSecret: process.env.REACT_APP_PUSHER_SECRET,
  pusherCluster: process.env.REACT_APP_PUSHER_CLUSTER,
  pusherScheme: process.env.REACT_APP_PUSHER_SCHEME,
  pusherPort: process.env.REACT_APP_PUSHER_PORT,
  broadcaster: process.env.REACT_APP_BROADCASTER,
  echoHost: process.env.REACT_APP_ECHO_HOST,
  reverbAppId: process.env.REACT_APP_REVERB_APP_ID,
  reverbHost: process.env.REACT_APP_REVERB_HOST,
  reverbAppKey: process.env.REACT_APP_REVERB_APP_KEY,
  nodeEnv: (process.env.NODE_ENV as NodeEnv) || NodeEnv.Development,
  reactDevServerUrl: process.env.REACT_DEV_SERVER_URL,
};
